const TwitterIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 22 18"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.265 2.64983C20.495 2.98983 19.685 3.20983 18.845 3.30983C19.725 2.77983 20.385 1.94983 20.695 0.97983C19.865 1.46983 18.965 1.81983 18.025 1.99983C16.435 0.29983 13.765 0.21983 12.065 1.81983C10.975 2.84983 10.505 4.37983 10.845 5.83983C7.455 5.66983 4.30501 4.06983 2.16501 1.43983C1.04501 3.35983 1.615 5.81983 3.465 7.05983C2.795 7.03983 2.14499 6.85983 1.55499 6.52983V6.57983C1.55499 8.58983 2.965 10.3198 4.935 10.7098C4.315 10.8798 3.665 10.8998 3.035 10.7798C3.585 12.4898 5.165 13.6698 6.965 13.6998C5.475 14.8698 3.62499 15.5098 1.73499 15.4998C1.40499 15.4998 1.06499 15.4798 0.734985 15.4398C2.66499 16.6798 4.905 17.3298 7.185 17.3298C13.755 17.3698 19.125 12.0798 19.165 5.50983C19.165 5.45983 19.165 5.39983 19.165 5.34983C19.165 5.16983 19.165 4.98983 19.155 4.79983C19.975 4.19983 20.695 3.46983 21.255 2.61983L21.265 2.64983Z"
        fill="inherit"
      />
    </svg>
  )
}

export default TwitterIcon
